import request from '@/utilsCloud/request'
import port from './port'


// 获取专业课程课程包列表
export function getPersonalApprovalSinglePackageList(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getPersonalApprovalSinglePackageList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



// 获取专业课程课程包列表
export function getEmployeeDetail(data) {
  return request({
    url: port.biz + '/employee/employeeDetail',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}



// 获取专业课程课程包列表
export function getCoursebypackagebagFromHome(query,isEnterprise) {
  let url = isEnterprise ?'/home/getCourseByPackageByEnterpriseHome':'/home/getCoursebypackagebagFromHome'
  return request({
    url: port.course + url,
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 课程列表
export function getEnterpriseStudyList(query, isEnterprise) {
  let url = isEnterprise ?'/home/getEnterpriseStudyListFromHome':'/home/getEnterpriseStudyList'
  return request({
    url: port.course + url,
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 查询精品课程/私有课程 列表
export function getQualityAndIntensiveCourseList(query) {
  return request({
    url: port.course + '/home/getQualityAndIntensiveCourseList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 培训记录主列表
export function getTrainingRecordPackagebagList(query,isEntp) {
  let url = isEntp?'/statisticsAnalysis/getTrainingRecordPackagebagListBiz':'/statisticsAnalysis/getTrainingRecordPackagebagList'
  return request({
    url: port.stat + url,
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 培训记录详情
export function getTrainingRecord(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getTrainingRecord',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 获取课程学习列表
export function getEmployeeStudyList(query) {
  return request({
    url: port.course + '/home/getEmployeeStudyList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取学习时长
export function getMustAndStartingCourse(query) {
  return request({
    url: port.course + '/home/getMustAndStartingCourse',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}

// 我的练习--练习记录
export function getExerciseRecordList(query) {
  return request({
    url: port.exam + '/exercise/exerciseRecordList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 获取考试记录
export function examRecordList(query) {
  return request({
    url: port.exam + '/exam/examRecordList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 我的审核列表
export function getPersonalCheckPackagebagList(query) {
  return request({
    url: port.stat + '/statisticsAnalysis/getPersonalCheckPackagebagList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 我的练习--我的错题
export function exerciseErrorsList(query) {
  return request({
    url: port.exam + '/exercise/exerciseErrorsList',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


// 我的练习--我的错题
export function getExamRecordsForReviewOrg(query) {
  return request({
    url: port.exam + '/exam/getExamRecordsForReviewOrg',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}


export function exerciseDetail(query) {
  return request({
    url: port.exam + '/exercise/exerciseDetail',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'get',
    params: query
  })
}



export function commitApprovalPackageRecords(data) {
  return request({
    url: port.stat + '/statisticsAnalysis/commitApprovalPackageRecords',
    headers: {
      isToken: true,
      isEntpId: true
    },
    method: 'post',
    data: data
  })
}


// 课程培训记录列表数据
export function getBizCourseRecord(query) {
  return request({
    url: '/eceping-course/order/getBizCourseRecord',
    method: 'get',
    headers: {
      isToken: true,
      isEntpId: true
    },
    params: query
  })
}

// 课程培训记录详情
export function getBizCourseRecordDetail(query) {
  return request({
    url: '/eceping-course/order/getBizCourseRecordDetail',
    method: 'get',
    headers: {
      isToken: true,
      isEntpId: true
    },
    params: query
  })
}



// WEBPACK FOOTER //
// ./src/apiCloud/studyCentre.js